/*
	支払方法管理画面
	選択中クレジットカード情報
*/

import React, { memo } from 'react';
import classes from './selecting-credit-card-info.module.scss';
import { PeriodicPaymentDetailToken } from 'requests/RequestPeriodicPayment';

type Props = {
	paymentTokens: PeriodicPaymentDetailToken;
};
export const SelectingCreditCardInfo = memo((props: Props) => {
	const { paymentTokens } = props;

	return (
		<div className={classes.paymentCreditCardInput}>
			<div className="form-box">
				<div className="form-head">
					<label htmlFor="">カード番号 （Card Number）</label>
				</div>
				<div className={`${classes.marginLeft20} form-input width50`}>
					<label htmlFor="">{`**** **** **** ${paymentTokens.last_digits}`}</label>
				</div>
			</div>
			<div className="form-box">
				<div className="form-head">
					<label htmlFor="">有効期限 （Expiration Date）</label>
				</div>
				<div className={`${classes.marginLeft20} ${classes.paymentCreditExpirationDateRow} form-input width50`}>
					<label htmlFor="">{`${paymentTokens.expiry.split('-')[1]} / ${paymentTokens.expiry.split('-')[0]}`}</label>
				</div>
			</div>
		</div>
	);
});
